import { Text } from "@mantine/core"

import { ButtonWithMenu } from "../Buttons/ButtonWithMenu/ButtonWithMenu.tsx"

export type LanguageItem = {
  label: string
  value: string
  icon: JSX.Element
}
type Props = {
  variant?: "light" | "dark"
  currentLocale: string
  languageItems: LanguageItem[]
  handleLanguageChange: (locale: string) => void
}

export const AppLanguageMenu = ({
  variant = "light",
  languageItems,
  currentLocale,
  handleLanguageChange,
}: Props) => {
  return (
    <ButtonWithMenu
      items={languageItems.map((languageItem) => ({
        label: languageItem.label,
        icon: languageItem.icon,
        onClick: () => handleLanguageChange(languageItem.value),
      }))}
      bg="transparent"
      c={variant == "light" ? "var(--mantine-color-text)" : "white"}
      dropDownWidth="fit-content"
    >
      <Text>{currentLocale}</Text>
    </ButtonWithMenu>
  )
}
